import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import useMediaQuery from '@mui/material/useMediaQuery';
import { alpha, useTheme } from '@mui/material/styles';
import { colors } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

const About = () => {
  const [config, setConfig] = useState({ base_image_url: '' });
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  // ✅ PDF links for each year
  const pdf1 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/alumini/alumni_2k16_17.pdf`;
  const pdf2 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/alumini/alumni_2k17_18.pdf`;
  const pdf3 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/alumini/alumni_2k18_19.pdf`;

  // // ✅ Correct Excel paths (2017, 2018, 2019)
  // const excel2017 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/alumini/2017.xlsx`;
  // const excel2018 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/alumini/2018.xlsx`;
  // const excel2019 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/alumini/2019.xlsx`;

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  // ✅ Data mock
  const mock = [
    {
      title: 'Alumni 2025 - 26',
      description: "We are proud to share remarkable accomplishments of our alumni...",
      illustration: '//pic.onlinewebfonts.com/svg/img_135736.png',
      illustrationDark: '//pic.onlinewebfonts.com/svg/img_135736.png',
      color: colors.green[200],
      href: '/alumini-meet-2024',
    },
    {
      title: 'Alumni 2024 - 25',
      description: "We are proud to share remarkable accomplishments of our alumni...",
      illustration: '//pic.onlinewebfonts.com/svg/img_135736.png',
      illustrationDark: '//pic.onlinewebfonts.com/svg/img_135736.png',
      color: colors.green[200],
      href: '/alumini-meet-2024',
    },
    {
      title: 'Alumni 2023 - 24',
      description: "We are proud to share remarkable accomplishments of our alumni...",
      illustration: '//pic.onlinewebfonts.com/svg/img_135736.png',
      illustrationDark: '//pic.onlinewebfonts.com/svg/img_135736.png',
      color: colors.green[200],
      href: '/alumni-2024',
    },
    {
      title: 'Alumni 2022 - 23',
      description: "We are delighted to share with you the remarkable success stories...",
      illustration: '//pic.onlinewebfonts.com/svg/img_135736.png',
      illustrationDark: '//pic.onlinewebfonts.com/svg/img_135736.png',
      color: colors.green[200],
      href: '/alumni-2023',
    },
    {
      title: 'Alumni 2021 - 22',
      description: "Creating an engaged, supportive alumni network is crucial...",
      illustration: '//pic.onlinewebfonts.com/svg/img_135736.png',
      illustrationDark: '//pic.onlinewebfonts.com/svg/img_135736.png',
      color: colors.green[200],
      href: '/alumni-2022',
    },
    {
      title: 'Alumni 2020 - 21',
      description: "Over the years, our students have made us proud...",
      illustration: '//pic.onlinewebfonts.com/svg/img_135736.png',
      illustrationDark: '//pic.onlinewebfonts.com/svg/img_135736.png',
      color: colors.green[200],
      href: '/alumni-2021',
    },
    {
      title: 'Alumni 2019 - 20',
      description: "Creating an engaged, supportive alumni network is crucial...",
      illustration: '//pic.onlinewebfonts.com/svg/img_135736.png',
      illustrationDark: '//pic.onlinewebfonts.com/svg/img_135736.png',
      color: colors.blue[200],
      href:'/Alumni',
    },
    {
      title: 'Alumni 2018 - 19',
      description: 'The school congratulates the students of Class 12 (2018-19)...',
      illustration: '//pic.onlinewebfonts.com/svg/img_135736.png',
      illustrationDark: '//pic.onlinewebfonts.com/svg/img_135736.png',
      color: colors.purple[200],
      pdf: pdf3,
      // excel: excel2019,  // ✅ 2018-19 uses 2019.xlsx
    },
    {
      title: 'Alumni 2017 - 18',
      description: 'The School congratulates the Students of Class 12 (2017 - 2018)...',
      illustration: '//pic.onlinewebfonts.com/svg/img_135736.png',
      illustrationDark: '//pic.onlinewebfonts.com/svg/img_135736.png',
      pdf: pdf2,
      color: colors.green[200],
      // excel: excel2018,  // ✅ 2017-18 uses 2018.xlsx
    },
    {
      title: 'Alumni 2016 - 17',
      description: 'Creating an engaged, supportive alumni network is crucial...',
      illustration: '//pic.onlinewebfonts.com/svg/img_135736.png',
      illustrationDark: '//pic.onlinewebfonts.com/svg/img_135736.png',
      pdf: pdf1,
      // excel: excel2017,  // ✅ 2016-17 uses 2017.xlsx
      color: colors.blue[200],
    },
  ];

  // ✅ Handle Read More click
   const handleReadMore = (item) => {
    if (item.pdf) {
      window.open(item.pdf, '_blank');
    } else if (item.href) {
      window.open(item.href, '_blank');
    }
  };

  // const handleClose = () => {
  //   setOpen(false);
  //   setSelectedItem(null);
  // };

  return (
    <Box>
      <Grid container spacing={isMd ? 10 : 4}>
        {mock.map((item, i) => (
          <Grid
            key={i}
            item
            xs={10}
            md={4}
            data-aos="fade-up"
            data-aos-delay={i * 100}
            data-aos-offset={100}
            data-aos-duration={600}
          >
            <Box
              component={Card}
              height={1}
              bgcolor={alpha(item.color || colors.grey[200], 0.2)}
              boxShadow={0}
            >
              <CardContent sx={{ padding: 4 }}>
                <Box
                  display="flex"
                  justifyContent="center"
                  marginBottom={{ xs: 2, md: 2 }}
                  sx={{
                    '& .lazy-load-image-loaded': {
                      maxWidth: { xs: '50%', md: '50%' },
                    },
                  }}
                >
                  <Box
                    component={LazyLoadImage}
                    effect="blur"
                    src={theme.palette.mode === 'light'
                      ? item.illustration
                      : item.illustrationDark}
                    width={1}
                  />
                </Box>
                <Box>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
                    {item.title}
                  </Typography>
                  <Typography color="text.secondary" align="justify">
                    {item.description}
                  </Typography>

                  <Button
                    size="large"
                    onClick={() => handleReadMore(item)}
                    sx={{ marginTop: 2 }}
                  >
                    <Typography>Read more</Typography>
                  </Button>
                </Box>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default About;
